import React from 'react';

export const LoaderRoutesSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 72 55" {...props}>
    <g fill="none" stroke="#2A99B7" strokeWidth="0.7" strokeLinecap="round">
      <line
        x1="35.5"
        y1="40"
        x2="23.5"
        y2="31"
        pathLength={100}
        strokeDasharray="100"
        className="logo-line line-1"
      />
      <line
        x1="35.5"
        y1="40"
        x2="33"
        y2="49"
        pathLength={100}
        strokeDasharray="100"
        className="logo-line line-2"
      />
      <line
        x1="35.5"
        y1="40"
        x2="56.5"
        y2="45.5"
        pathLength={100}
        strokeDasharray="100"
        className="logo-line line-3"
      />
      <line
        x1="35.5"
        y1="40"
        x2="64.5"
        y2="26.5"
        pathLength={100}
        strokeDasharray="100"
        className="logo-line line-4"
      />
    </g>
    <g fill="#2A99B7">
      <circle cx="23.5" cy="31" r="1.5" className="logo-dot dot-1" />
      <circle cx="33" cy="49" r="1.5" className="logo-dot dot-2" />
      <circle cx="56.5" cy="45.5" r="1.5" className="logo-dot dot-3" />
      <circle cx="64.5" cy="26.5" r="1.5" className="logo-dot dot-4" />
    </g>
  </svg>
);

export default LoaderRoutesSvg;
